import axios from 'axios';
import {
  cleanLocalStorage,
  errorToast,
  getDeviceToken,
  getJWTToken,
  getLocalStorageItem,
  setLocalStorageItem
} from '../utils/helper';
import { API_BASE_URL } from '../core/env.configs';

const BASE_URL = API_BASE_URL || 'https://staging-api.shoorah.io/';

export const GetApi = async (url, isHeader = true) => {
  try {
    const data = await axios.get(BASE_URL + url, {
      headers: isHeader
        ? {
            Authorization: getJWTToken()
          }
        : {}
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

export const PostApi = async (url, reqBody, isHeader = false, flag = false, onUploadProgress) => {
  try {
    const data = await axios.post(BASE_URL + url, reqBody, {
      headers: isHeader
        ? {
            deviceToken: getLocalStorageItem('deviceToken'),
            deviceType: 3,
            Authorization: getJWTToken()
          }
        : {},
      ...(onUploadProgress ? { onUploadProgress } : {})
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

export const DeleteApi = async (url, isHeader = false) => {
  try {
    const data = await axios.delete(BASE_URL + url, {
      headers: isHeader
        ? {
            'Content-Type': 'application/json',
            accept: 'application/json',
            Authorization: getJWTToken(),
            deviceToken: getDeviceToken()
          }
        : {}
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

export const PutApi = async (url, reqBody, isHeader) => {
  try {
    const data = await axios.put(BASE_URL + url, reqBody !== null && reqBody, {
      headers: isHeader
        ? {
            deviceToken: getLocalStorageItem('deviceToken'),
            deviceType: 3,
            Authorization: getJWTToken()
          }
        : {}
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const PutApiWithFormData = async (tag = '', reqBody, isHeader = false, flag = false) => {
  let flagCheck = flag
    ? 'multipart/form-data; boundary=----WebKitFormBoundaryueI4YvrqiXxUgVGA'
    : 'application/json';

  try {
    const data = await axios.put(BASE_URL + 'admin/v1' + tag, reqBody, {
      headers: isHeader
        ? {
            'Content-Type': flagCheck,
            accept: flagCheck,
            Authorization: getJWTToken()
          }
        : {}
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

export const PatchApi = async (tag = '', reqBody, isHeader, isJSON = false) => {
  const contentType = {
    'Content-Type': 'application/json'
  };
  const headers = {
    accept: 'application/json',
    Authorization: getJWTToken(),
    ...(isJSON ? contentType : {})
  };
  try {
    const data = await axios.patch(BASE_URL + 'admin/v1' + tag, reqBody !== null && reqBody, {
      headers: isHeader ? headers : {}
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const ErrorHandler = async (e) => {
  if (e.response?.data?.message) {
    if (e.response?.data?.code === 498) {
      RefreshToken();
    } else if (e.response?.data?.code === 401) {
      errorToast(e.response?.data?.message);
      cleanLocalStorage();
      window.location.href = '/login';
    } else {
      errorToast(e.response?.data?.message);
    }
  } else if (e.response?.data) {
    if (e.response?.data?.meta?.code === 498) {
      RefreshToken();
    } else if (e.response?.data?.code === 401) {
      errorToast(e.response?.data?.message);
      cleanLocalStorage();
      window.location.href = '/login';
    } else {
      errorToast(e.response?.data?.meta?.message);
    }
  } else {
    errorToast('Something went wrong');
  }
};

const RefreshToken = async () => {
  await axios
    .post(
      `${BASE_URL}admin/v1/refresh-token`,
      {},
      { headers: { 'refresh-token': getLocalStorageItem('refreshToken') } }
    )
    .then(async (response) => {
      if (response.data.meta.code === 1) {
        setLocalStorageItem('token', response.data.meta.token);
        window.location.reload();
      }
    })
    .catch(async (error) => {
      if (error.response.data.code === 401) {
        cleanLocalStorage();
        window.location.href = '/login';
      } else {
        cleanLocalStorage();
        window.location.href = '/login';
      }
    });
};

const DownloadApi = async (tag = '', fileName = 'SosReport') => {
  try {
    const res = await axios.get(BASE_URL + 'admin/v1' + tag, {
      headers: {
        deviceType: 3,
        Authorization: getJWTToken()
      },
      responseType: 'blob'
    });
    const blob = new Blob([res.data], { type: 'application/pdf' });
    const url_2 = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url_2;
    a.download = `${fileName}.pdf`; // Specify the filename
    a.click();
    window.URL.revokeObjectURL(url_2);
  } catch (err) {}
};

const PostApiBlob = async (tag = '', reqBody) => {
  try {
    const res = await axios.post(BASE_URL + 'admin/v1' + tag, reqBody, {
      headers: {
        deviceType: 3,
        Authorization: getJWTToken()
      },
      responseType: 'blob'
    });
    const blob = new Blob([res.data], { type: 'application/pdf' });
    const url_2 = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url_2;
    a.download = reqBody.graphName; // Specify the filename
    a.click();
    window.URL.revokeObjectURL(url_2);
  } catch (e) {
    ErrorHandler(e);
  }
};

// ===================================== Wearable Data Stats =====================================
export const getAdminWearableDataStats = async () => {
  try {
    const data = await axios.get(BASE_URL + 'admin/v1/wearable-data-stats', {
      headers: {
        Authorization: getJWTToken()
      }
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

export const getAdminSleepTrends = async (duration = 'weekly') => {
  try {
    const data = await axios.get(BASE_URL + `admin/v1/sleep-trends?duration=${duration}`, {
      headers: {
        Authorization: getJWTToken()
      }
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

export const getAdminHeartRateTrends = async (duration = 'weekly') => {
  try {
    const data = await axios.get(BASE_URL + `admin/v1/heart-rate-trends?duration=${duration}`, {
      headers: {
        Authorization: getJWTToken()
      }
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

export const getAdminStepsTrends = async (duration = 'weekly') => {
  try {
    const data = await axios.get(BASE_URL + `admin/v1/steps-trends?duration=${duration}`, {
      headers: {
        Authorization: getJWTToken()
      }
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

export const getUserHealthSummary = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params).toString();
    const data = await axios.get(BASE_URL + `admin/v1/user-health-summary?${queryParams}`, {
      headers: {
        deviceType: 1,
        Authorization: getJWTToken()
      }
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};
